<mat-card class="cardWithShadow overflow-hidden">
  <div class="status-banner bg-light text-dark">
    <div class="d-flex flex-column">
      <mat-card-title class="mat-mdc-card-title m-b-0 f-s-16">
        {{technician?.lastname | titlecase}} {{technician?.name | titlecase}}
      </mat-card-title>
    </div>
  </div>
  <mat-card-content class="text-center">
    <div *ngIf="technician?.avatar; else elseImageUser" [style.backgroundImage]="'url(' + technician?.avatar + ')'" class="rounded-circle align-items-lg-center" style="width: 100px; height: 100px; background-size: cover; margin: auto;"></div>

    <ng-template #elseImageUser>
      <img src="assets/images/users/user-img.jpg" class="rounded-circle border p-5" width="100"/>
    </ng-template>
    <div class="d-flex flex-col gap-20 m-t-16">
      <div>
        <h4 mat-card-title>
          {{technician?.name | titlecase}} {{technician?.lastname | titlecase}}
        </h4>
        <span class="f-s-12">{{"technicians.technicians" | translate}}</span>
        <span class="f-s-14 d-block">{{ technician?.email }}</span>
      </div>
      <div class="d-flex gap-8 justify-content-center">
        <button mat-button class="b-1 border-primary text-primary" (click)="openTechnician(technician)">
          {{"technicians.profile" | translate}}
        </button>
      </div>
<!--      <span class="f-s-14"> Via S.Piox 12, 80100, Napoli (NA)</span>-->
      <span class="f-s-14">  {{"personal_details.phone" | translate}}: {{technician?.prefix?.prefix}} {{technician?.phone}}</span>
    </div>
  </mat-card-content>
  <mat-divider></mat-divider>
  <div class="row">
    <div class="col-4 p-y-12">
      <a href="javascript:void(0)" (click)="viewFile()" class="text-decoration-none f-s-14 f-w-500 d-flex justify-content-center align-items-center gap-4">
        <i-tabler name="qr_code" class="icon-18 d-flex"></i-tabler>
      </a>
    </div>
    <div class="col-4 p-y-12">
      <a href="javascript:void(0)" (click)="downloadQrcode()" class="text-decoration-none f-s-14 f-w-500 d-flex justify-content-center align-items-center gap-4">
        <i-tabler name="download" class="icon-18 d-flex"></i-tabler>
      </a>
    </div>
    <div class="col-4 p-y-12">
      <a href="javascript:void(0)" (click)="sendEmail(technician)" class="text-decoration-none f-s-14 f-w-500 d-flex justify-content-center align-items-center gap-4">
        <i-tabler name="send-2" class="icon-18 d-flex"></i-tabler>
      </a>
    </div>
  </div>
</mat-card>
